module.exports = __webpack_public_path__ + "static/fonts/SCDream9.41be699.otf";